import TickerForm from "../TickerForm";
import React, { useState, useEffect, useContext, useRef, useMemo } from "react";
import { useUser } from "../context/UserContext";
import SignInPage from "../pages/signinpage";
import SignIn from "../components/SignIn";
import { Helmet } from "react-helmet";
import LandingPage from "./LandingPage";
import UserContext from "../context/UserContext";
import kopiaStockSleuthImage from "../images/Kopia_STOCK_SLEUTH-removebg-preview-1.png";
import axios from "../api/client";
import { createWatchlist, deleteWatchlist, getFavorites, getPortfolio, removeFavorite, renameWatchlist } from "../api/private";
import swipeW from "../images/swipew.png";
  import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import podiumW from "../images/leaderboardw.png";
import funnelG from "../images/funnel.png";
import funnel from "../images/FunnelHome.png";
import swipe from "../images/swipeHome.png";
import analuyz from "../images/analyzeHome.png";
import Chart from "react-apexcharts";
import compete from "../images/TrophyHome.png";
import scanner from "../images/scannerScreen.png";
import card2 from "../images/card2.png";
import ArticleList from "./ArticlesList.js";
import 'katex/dist/katex.min.css';
import { BlockMath, InlineMath } from 'react-katex';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useParams,
  navigate,
  useLocation,
  Navigate,
  useNavigate,
  NavLink,
} from "react-router-dom";
//
const modifySecurityName = (name) => {
  return name
    // share-type labels
    .replace(/\s*-\s*Common Stock$/i, "")
    .replace(/\s*Common Stock$/i, "")
    .replace(/\s*Capital Stock$/i, "")
    .replace(/\s*Ordinary Shares$/i, "")
    .replace(/\s*-\s*Common Shares$/i, "")

    // share classes
    .replace(/\s*-\s*Class [A-C]$/i, "")
    .replace(/\s*Class [A-C]$/i, "")

    // corporate designators
    .replace(/\s*-\s*Inc(?:orporated)?\.?$/i, "")
    .replace(/\s*Inc(?:orporated)?\.?$/i, "")
    .replace(/\s*-\s*Corp(?:oration)?\.?$/i, "")
    .replace(/\s*Corp(?:oration)?\.?$/i, "")
    .replace(/\s*-\s*Co\.?$/i, "")
    .replace(/\s*Co\.?$/i, "")
    .replace(/\s*-\s*Company$/i, "")
    .replace(/\s*Company$/i, "")
    .replace(/\s*-\s*Limited$/i, "")
    .replace(/\s*Limited$/i, "")
    .replace(/\s*-\s*Ltd\.?$/i, "")
    .replace(/\s*Ltd\.?$/i, "")

    // clean up trailing dash, commas, or extra whitespace
    .replace(/[\s,-]+$/g, "")
    .trim();
};
dayjs.extend(utc);
dayjs.extend(timezone);
const FeaturedCard = ({ item }) => {
  const subline = item.sector || item.industry ? [item.sector, item.industry].filter(Boolean).join(" • ") : item.ticker;
  return (
    <a
      href={item.link}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        textDecoration: "none",
        color: "inherit",
        padding: "12px 14px",

      }}
    >
      <div
        style={{
          width: 36,
          height: 36,
          borderRadius: 8,
          background: "#f3f4f6",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        {item.logo ? (
          <img
            src={item.logo}
            alt={item.ticker}
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        ) : (
          <span style={{ fontWeight: 700, color: "#9ca3af" }}>
            {item.ticker?.[0] || "?"}
          </span>
        )}
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <div style={{ fontSize: 14, fontWeight: "normal", textAlign: "left", fontFamily: "Lexend" }}>
          {item.shortName || item.ticker}
        </div>
        <div style={{ fontSize: 10, color: "rgb(103, 103, 107)", textAlign: "left" }}>
          {subline}
        </div>
      </div>
    </a>
  );
};


const COLUMN_CONFIG = [
  { key: "price",            label: "Price" },
  { key: "pe",               label: "P/E ratio" },
  { key: "ps",               label: "P/S ratio" },
  { key: "pb",               label: "P/B ratio" },
  { key: "eps",              label: "EPS (ttm)" },
  { key: "nextEarningsDate", label: "Next earnings" },
  { key: "mktCap",           label: "Market Cap" },
  { key: "changePct",        label: "Change %" },
  { key: "fiftyTwoW",        label: "52W Range" },
];

const DEFAULT_SELECTED = ["price", "pe", "pb"]; // your current default set

const loadSelectedColumns = () => {
  try {
    const raw = localStorage.getItem("watchlist_selected_cols");
    if (!raw) return DEFAULT_SELECTED;
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed) && parsed.length) return parsed;
    return DEFAULT_SELECTED;
  } catch {
    return DEFAULT_SELECTED;
  }
};

const saveSelectedColumns = (arr) => {
  try {
    localStorage.setItem("watchlist_selected_cols", JSON.stringify(arr));
  } catch {}
};

const formatNumber = (n, digits = 2) =>
  typeof n === "number" && !isNaN(n) ? n.toFixed(digits) : "-";

const formatMarketCap = (n) => {
  if (typeof n !== "number" || isNaN(n)) return "-";
  if (n >= 1e12) return (n / 1e12).toFixed(2) + "T";
  if (n >= 1e9)  return (n / 1e9).toFixed(2) + "B";
  if (n >= 1e6)  return (n / 1e6).toFixed(2) + "M";
  if (n >= 1e3)  return (n / 1e3).toFixed(2) + "K";
  return n.toFixed(0);
};


const GearIcon = ({
  width = "16px",
  height = "16px",
  fill = "black ",
  ...props
}) => (
  <svg
    fill={fill}
    width={width}
    height={height}
    viewBox="0 0 54 54"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    {...props}
  >
    <path d="M51.22,21h-5.052c-0.812,0-1.481-0.447-1.792-1.197s-0.153-1.54,0.42-2.114l3.572-3.571 c0.525-0.525,0.814-1.224,0.814-1.966c0-0.743-0.289-1.441-0.814-1.967l-4.553-4.553c-1.05-1.05-2.881-1.052-3.933,0l-3.571,3.571 c-0.574,0.573-1.366,0.733-2.114,0.421C33.447,9.313,33,8.644,33,7.832V2.78C33,1.247,31.753,0,30.22,0H23.78 C22.247,0,21,1.247,21,2.78v5.052c0,0.812-0.447,1.481-1.197,1.792c-0.748,0.313-1.54,0.152-2.114-0.421l-3.571-3.571 c-1.052-1.052-2.883-1.05-3.933,0l-4.553,4.553c-0.525,0.525-0.814,1.224-0.814,1.967c0,0.742,0.289,1.44,0.814,1.966l3.572,3.571 c0.573,0.574,0.73,1.364,0.42,2.114S8.644,21,7.832,21H2.78C1.247,21,0,22.247,0,23.78v6.439C0,31.753,1.247,33,2.78,33h5.052 c0.812,0,1.481,0.447,1.792,1.197s0.153,1.54-0.42,2.114l-3.572,3.571c-0.525,0.525-0.814,1.224-0.814,1.966 c0,0.743,0.289,1.441,0.814,1.967l4.553,4.553c1.051,1.051,2.881,1.053,3.933,0l3.571-3.572c0.574-0.573,1.363-0.731,2.114-0.42 c0.75,0.311,1.197,0.98,1.197,1.792v5.052c0,1.533,1.247,2.78,2.78,2.78h6.439c1.533,0,2.78-1.247,2.78-2.78v-5.052 c0-0.812,0.447-1.481,1.197-1.792c0.751-0.312,1.54-0.153,2.114,0.42l3.571,3.572c1.052,1.052,2.883,1.05,3.933,0l4.553-4.553 c0.525-0.525,0.814-1.224,0.814-1.967c0-0.742-0.289-1.44-0.814-1.966l-3.572-3.571c-0.573-0.574-0.73-1.364-0.42-2.114 S45.356,33,46.168,33h5.052c1.533,0,2.78-1.247,2.78-2.78V23.78C54,22.247,52.753,21,51.22,21z M52,30.22 C52,30.65,51.65,31,51.22,31h-5.052c-1.624,0-3.019,0.932-3.64,2.432c-0.622,1.5-0.295,3.146,0.854,4.294l3.572,3.571 c0.305,0.305,0.305,0.8,0,1.104l-4.553,4.553c-0.304,0.304-0.799,0.306-1.104,0l-3.571-3.572c-1.149-1.149-2.794-1.474-4.294-0.854 c-1.5,0.621-2.432,2.016-2.432,3.64v5.052C31,51.65,30.65,52,30.22,52H23.78C23.35,52,23,51.65,23,51.22v-5.052 c0-1.624-0.932-3.019-2.432-3.64c-0.503-0.209-1.021-0.311-1.533-0.311c-1.014,0-1.997,0.4-2.761,1.164l-3.571,3.572 c-0.306,0.306-0.801,0.304-1.104,0l-4.553-4.553c-0.305-0.305-0.305-0.8,0-1.104l3.572-3.571c1.148-1.148,1.476-2.794,0.854-4.294 C10.851,31.932,9.456,31,7.832,31H2.78C2.35,31,2,30.65,2,30.22V23.78C2,23.35,2.35,23,2.78,23h5.052 c1.624,0,3.019-0.932,3.64-2.432c0.622-1.5,0.295-3.146-0.854-4.294l-3.572-3.571c-0.305-0.305-0.305-0.8,0-1.104l4.553-4.553 c0.304-0.305,0.799-0.305,1.104,0l3.571,3.571c1.147,1.147,2.792,1.476,4.294,0.854C22.068,10.851,23,9.456,23,7.832V2.78 C23,2.35,23.35,2,23.78,2h6.439C30.65,2,31,2.35,31,2.78v5.052c0,1.624,0.932,3.019,2.432,3.64 c1.502,0.622,3.146,0.294,4.294-0.854l3.571-3.571c0.306-0.305,0.801-0.305,1.104,0l4.553,4.553c0.305,0.305,0.305,0.8,0,1.104 l-3.572,3.571c-1.148,1.148-1.476,2.794-0.854,4.294c0.621,1.5,2.016,2.432,3.64,2.432h5.052C51.65,23,52,23.35,52,23.78V30.22z" />
    <path d="M27,18c-4.963,0-9,4.037-9,9s4.037,9,9,9s9-4.037,9-9S31.963,18,27,18z M27,34c-3.859,0-7-3.141-7-7s3.141-7,7-7 s7,3.141,7,7S30.859,34,27,34z" />
  </svg>
);



const fetchStockDetails = async (ticker) => {
  try {
    const res = await fetch(
      `https://stocksleuth.xyz:5000/auth/getstockdetails?symbol=${ticker}`
    );
    const data = await res.json();

    let logo = null;
    if (data.logo) {
      const buf = new Uint8Array(data.logo.data);
      const b64 = btoa(String.fromCharCode.apply(null, buf));
      logo = `data:image/png;base64,${b64}`;
    }

    const shortName =
      data.security_name
        ? modifySecurityName(data.security_name)
        : (data.name || ticker);

    return {
      logo,
      shortName,
      sector: data.sector || null,
      industry: data.industry || null,
    };
  } catch (e) {
    console.error("getstockdetails failed for", ticker, e);
    return { logo: null, shortName: ticker, sector: null, industry: null };
  }
};
// Put this above Dashboard (same file) or in its own file and import it.
const TradingViewOverview = React.memo(function TradingViewOverview() {
  const outerRef = useRef(null);
  const widgetRef = useRef(null);
  const injectedRef = useRef(false);

  // Optional: re-inject when the container gets (non-zero) size.
  useEffect(() => {
    if (!outerRef.current) return;

    const hasSize = () => {
      const el = outerRef.current;
      const r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    };

    const inject = () => {
      if (!widgetRef.current || injectedRef.current) return;

      // Clear any previous children (safety)
      widgetRef.current.replaceChildren();

      const script = document.createElement("script");
      script.src =
        "https://s3.tradingview.com/external-embedding/embed-widget-market-overview.js";
      script.async = true;
      script.type = "text/javascript";
      // IMPORTANT: append to the __widget node, not the outer container
      script.innerHTML = JSON.stringify({
        colorTheme: "light",
        dateRange: "12M",
        showChart: true,
        locale: "en",
        width: "100%",
        height: "100%",
        isTransparent: false,
        showSymbolLogo: true,
        showFloatingTooltip: false,
        plotLineColorGrowing: "rgba(51, 22, 255, 1)",
        plotLineColorFalling: "rgba(51, 22, 255, 1)",
        gridLineColor: "rgba(240, 243, 250, 0)",
        scaleFontColor: "rgba(15, 15, 15, 1)",
        belowLineFillColorGrowing: "rgba(41, 98, 255, 0.12)",
        belowLineFillColorFalling: "rgba(41, 98, 255, 0.12)",
        belowLineFillColorGrowingBottom: "rgba(41, 98, 255, 0)",
        belowLineFillColorFallingBottom: "rgba(41, 98, 255, 0)",
        symbolActiveColor: "rgba(41, 98, 255, 0.12)",
        tabs: [
          {
            title: "Indices",
            symbols: [
              { s: "FOREXCOM:SPXUSD", d: "S&P 500 Index" },
              { s: "FOREXCOM:NSXUSD", d: "US 100 Cash CFD" },
              { s: "FOREXCOM:DJI", d: "Dow Jones Industrial Average" },
              { s: "INDEX:NKY", d: "Japan 225" },
              { s: "INDEX:DEU40", d: "DAX Index" },
              { s: "FOREXCOM:UKXGBP", d: "FTSE 100" },
            ],
          },
          {
            title: "Forex",
            symbols: [
              { s: "FX:EURUSD", d: "EUR/USD" },
              { s: "FX:GBPUSD", d: "GBP/USD" },
              { s: "FX:USDJPY", d: "USD/JPY" },
              { s: "FX:USDCHF", d: "USD/CHF" },
              { s: "FX:AUDUSD", d: "AUD/USD" },
              { s: "FX:USDCAD", d: "USD/CAD" },
            ],
          },
          {
            title: "Futures",
            symbols: [
              { s: "BMFBOVESPA:ISP1!", d: "S&P 500 Futures" },
              { s: "BMFBOVESPA:EUR1!", d: "Euro Futures" },
              { s: "PYTH:WTI3!", d: "WTI Crude Oil" },
              { s: "BMFBOVESPA:ETH1!", d: "Hydrous Ethanol" },
              { s: "BMFBOVESPA:CCM1!", d: "Corn" },
            ],
          },
          {
            title: "Bonds",
            symbols: [
              { s: "EUREX:FGBL1!", d: "Euro Bund" },
              { s: "EUREX:FBTP1!", d: "Euro BTP" },
              { s: "EUREX:FGBM1!", d: "Euro BOBL" },
            ],
          },
        ],
      });

      widgetRef.current.appendChild(script);
      injectedRef.current = true;
    };

    if (hasSize()) {
      // Give React one tick to paint before injecting
      const t = setTimeout(inject, 0);
      return () => clearTimeout(t);
    }

    // If size is 0 (hidden grid/tab etc.), observe until it lays out
    const ro = new ResizeObserver(() => {
      if (hasSize()) {
        ro.disconnect();
        inject();
      }
    });
    ro.observe(outerRef.current);

    return () => {
      ro.disconnect();
    };
  }, []);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      injectedRef.current = false;
      if (widgetRef.current) widgetRef.current.replaceChildren();
    };
  }, []);

  return (
    <div
      className="tradingview-widget-container"
      ref={outerRef}
      style={{ width: "100%", height: "100%" }}
    >
      <div
        className="tradingview-widget-container__widget"
        ref={widgetRef}
        style={{ width: "100%", height: "100%" }}
      />
      <div className="tradingview-widget-copyright">
        <a
          href="https://www.tradingview.com/"
          rel="noopener nofollow"
          target="_blank"
        >
          <span className="blue-text">Track all markets on TradingView</span>
        </a>
      </div>
    </div>
  );
});





const Dashboard = () => {
  const [stockData, setStockData] = useState(null);
  const { user, isLoggedIn } = useUser();
  const [tod, setTod] = useState(null);
  const [portfolioSnapshot, setPortfolioSnapshot] = useState({
    loading: true,
    holdings: [],
    marketValue: 0,
    totalReturn: 0,
  });
const [watchlists, setWatchlists] = useState({});
const [activeWatchlistId, setActiveWatchlistId] = useState("1");

// NEW: modal state
const [wlModalOpen, setWlModalOpen] = useState(false);
const [wlModalMode, setWlModalMode] = useState("create"); // "create" | "edit"
const [wlModalName, setWlModalName] = useState("");
const [wlModalTargetId, setWlModalTargetId] = useState(null);
const [wlSaving, setWlSaving] = useState(false);
const [wlError, setWlError] = useState("");
const [removingTicker, setRemovingTicker] = useState(null);

useEffect(() => {
  if (!isLoggedIn || !user) return;

  let isActive = true;
  const loadPortfolioSnapshot = async () => {
    try {
      const response = await getPortfolio();
      const positions = response?.data?.portfolio || {};
      const tickers = Object.keys(positions);
      if (!tickers.length) {
        if (isActive) setPortfolioSnapshot({ loading: false, holdings: [], marketValue: 0, totalReturn: 0 });
        return;
      }

      const priceByTicker = Object.fromEntries(
        (Array.isArray(response?.data?.stockData) ? response.data.stockData : []).map((item) => [
          item.symbol,
          Number(item.regularMarketPrice ?? item.price),
        ])
      );
      const holdings = tickers.map((ticker) => {
        const purchases = Array.isArray(positions[ticker]) ? positions[ticker] : [];
        const shares = purchases.reduce((sum, purchase) => sum + (Number(purchase.shares) || 0), 0);
        const costBasis = purchases.reduce((sum, purchase) => sum + (Number(purchase.shares) || 0) * (Number(purchase.purchasePrice) || 0), 0);
        const fallbackPrice = shares ? costBasis / shares : 0;
        const currentPrice = Number.isFinite(priceByTicker[ticker]) ? priceByTicker[ticker] : fallbackPrice;
        return { ticker, shares, costBasis, value: Math.max(0, shares * currentPrice) };
      }).filter((holding) => holding.shares > 0);
      const marketValue = holdings.reduce((sum, holding) => sum + holding.value, 0);
      const costBasis = holdings.reduce((sum, holding) => sum + holding.costBasis, 0);
      const totalReturn = costBasis > 0 ? ((marketValue - costBasis) / costBasis) * 100 : 0;

      if (isActive) setPortfolioSnapshot({
        loading: false,
        holdings: holdings.sort((a, b) => b.value - a.value).slice(0, 3),
        marketValue,
        totalReturn,
      });
    } catch {
      if (isActive) setPortfolioSnapshot({ loading: false, holdings: [], marketValue: 0, totalReturn: 0 });
    }
  };

  loadPortfolioSnapshot();
  return () => { isActive = false; };
}, [isLoggedIn, user]);




// NEW: ESC to close modal
useEffect(() => {
  if (!wlModalOpen) return;
  const onKey = (e) => {
    if (e.key === "Escape") {
      setWlModalOpen(false);
    }
  };
  window.addEventListener("keydown", onKey);
  return () => window.removeEventListener("keydown", onKey);
}, [wlModalOpen]);
const openWatchlistManager = () => {
  setWlModalMode("create");
  setWlModalName("");
  setWlModalTargetId(null);
  setWlError("");
  setWlModalOpen(true);
};


const openRenameWatchlistModal = (id) => {
  const currentName = watchlists[id]?.name || "";
  setWlModalMode("edit");
  setWlModalTargetId(id);
  setWlModalName(currentName);
  setWlError("");
  setWlModalOpen(true);
};

// NEW: delete handler
const handleDeleteWatchlist = async (id) => {
  if (id === "1") return; // keep default safe

  const wlName = watchlists[id]?.name || `Watchlist ${id}`;
  const ok = window.confirm(`Delete "${wlName}"? This cannot be undone.`);
  if (!ok) return;

  try {
    setWlSaving(true);
    const { data } = await deleteWatchlist(id);

    const nextWatchlists = data?.watchlists || data?.favorites;

    setWatchlists((prev) => {
      const copy =
        nextWatchlists && typeof nextWatchlists === "object"
          ? nextWatchlists
          : { ...prev };

      if (!nextWatchlists) delete copy[id];

      if (activeWatchlistId === id) {
        const fallbackId = copy["1"] ? "1" : Object.keys(copy)[0] || null;
        setActiveWatchlistId(fallbackId || "1");
      }

      return copy;
    });
  } catch (err) {
    console.error("Delete watchlist failed", err);
    setWlError("Could not delete this watchlist. Please try again.");
  } finally {
    setWlSaving(false);
  }
};
const handleWatchlistModalSubmit = async (e) => {
  e.preventDefault();
  const name = wlModalName.trim();
  if (!name) {
    setWlError("Name cannot be empty.");
    return;
  }

  try {
    setWlSaving(true);
    setWlError("");

    if (wlModalMode === "create") {
      const res = await createWatchlist(name);

      const { watchlists: wlFromApi, newWatchlistId } = res.data || {};
      if (wlFromApi) {
        setWatchlists(wlFromApi);
        const idToActivate =
          newWatchlistId ||
          Object.keys(wlFromApi)[Object.keys(wlFromApi).length - 1];
        if (idToActivate) setActiveWatchlistId(String(idToActivate));
      }
    } else if (wlModalMode === "edit" && wlModalTargetId) {
      const res = await renameWatchlist(wlModalTargetId, name);
      const { watchlists: wlFromApi } = res.data || {};
      if (wlFromApi) {
        setWatchlists(wlFromApi);
      } else {
        setWatchlists((prev) => ({
          ...prev,
          [wlModalTargetId]: {
            ...(prev[wlModalTargetId] || {}),
            name,
          },
        }));
      }
    }

    // ✅ keep modal open, just reset form back to "create"
    setWlModalMode("create");
    setWlModalName("");
    setWlModalTargetId(null);
  } catch (err) {
    console.error("Watchlist save failed", err);
    setWlError("Something went wrong. Please try again.");
  } finally {
    setWlSaving(false);
  }
};
useEffect(() => {
  if (!wlModalOpen) return;
  const onKey = (e) => {
    if (e.key === "Escape") {
      setWlModalOpen(false);
    }
  };
  window.addEventListener("keydown", onKey);
  return () => window.removeEventListener("keydown", onKey);
}, [wlModalOpen]);



  const [isUserSet, setIsUserSet] = useState(false);
  const [earnings, setEarnings] = useState([]);
  useEffect(() => {
    if (user) {
      setIsUserSet(true);
    }
  }, [user]);
const [colPickerOpen, setColPickerOpen] = useState(false);
const [selectedCols, setSelectedCols] = useState(loadSelectedColumns());
const gearBtnRef = useRef(null); // so we can position popup near the gear
useEffect(() => {
  if (!colPickerOpen) return;
  const onClick = (e) => {
    // close if clicked outside the popup & the gear
    if (!document.getElementById("col-picker-pop")) {
      setColPickerOpen(false);
      return;
    }
    const pop = document.getElementById("col-picker-pop");
    if (!pop.contains(e.target) && !gearBtnRef.current?.contains(e.target)) {
      setColPickerOpen(false);
    }
  };
  document.addEventListener("mousedown", onClick);
  return () => document.removeEventListener("mousedown", onClick);
}, [colPickerOpen]);

useEffect(() => {

  let abort = false;

  (async () => {
    try {
      const res = await fetch('https://stocksleuth.xyz:5000/api/glossary/term-of-day');
      if (!res.ok) throw new Error('Failed to load term of day');
      const data = await res.json();
      if (!abort) setTod(data);
    } catch (e) {
      console.error(e);
      if (!abort) setTod(null);
    }
  })();

  return () => { abort = true; };
}, []);



  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
  
    // Clear *everything* (old widget + old script)
    container.innerHTML = '';
  
    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-market-overview.js';
    script.async = true;
    script.innerHTML = JSON.stringify({
      colorTheme: 'light',
      dateRange: '12M',
      showChart: true,
      locale: 'en',
      width: '100%',
      height: '100%',
      isTransparent: false,
      showSymbolLogo: true,
      showFloatingTooltip: false,
      plotLineColorGrowing: 'rgba(51, 22, 255, 1)',
      plotLineColorFalling: 'rgba(51, 22, 255, 1)',
      gridLineColor: 'rgba(240, 243, 250, 0)',
      scaleFontColor: 'rgba(15, 15, 15, 1)',
      belowLineFillColorGrowing: 'rgba(41, 98, 255, 0.12)',
      belowLineFillColorFalling: 'rgba(41, 98, 255, 0.12)',
      belowLineFillColorGrowingBottom: 'rgba(41, 98, 255, 0)',
      belowLineFillColorFallingBottom: 'rgba(41, 98, 255, 0)',
      symbolActiveColor: 'rgba(41, 98, 255, 0.12)',
      tabs: [
        {
          title: 'Indices',
          symbols: [
            { s: 'FOREXCOM:SPXUSD', d: 'S&P 500 Index' },
            { s: 'FOREXCOM:NSXUSD', d: 'US 100 Cash CFD' },
            { s: 'FOREXCOM:DJI',    d: 'Dow Jones Industrial Average' },
            { s: 'INDEX:NKY',       d: 'Japan 225' },
            { s: 'INDEX:DEU40',     d: 'DAX Index' },
            { s: 'FOREXCOM:UKXGBP', d: 'FTSE 100' },
          ],
        },
        {
          title: 'Forex',
          symbols: [
            { s: 'FX:EURUSD', d: 'EUR/USD' },
            { s: 'FX:GBPUSD', d: 'GBP/USD' },
            { s: 'FX:USDJPY', d: 'USD/JPY' },
            { s: 'FX:USDCHF', d: 'USD/CHF' },
            { s: 'FX:AUDUSD', d: 'AUD/USD' },
            { s: 'FX:USDCAD', d: 'USD/CAD' },
          ],
        },
        {
          title: 'Futures',
          symbols: [
            { s: 'BMFBOVESPA:ISP1!', d: 'S&P 500 Futures' },
            { s: 'BMFBOVESPA:EUR1!', d: 'Euro Futures' },
            { s: 'PYTH:WTI3!',       d: 'WTI Crude Oil' },
            { s: 'BMFBOVESPA:ETH1!', d: 'Hydrous Ethanol' },
            { s: 'BMFBOVESPA:CCM1!', d: 'Corn' },
          ],
        },
        {
          title: 'Bonds',
          symbols: [
            { s: 'EUREX:FGBL1!', d: 'Euro Bund' },
            { s: 'EUREX:FBTP1!', d: 'Euro BTP' },
            { s: 'EUREX:FGBM1!', d: 'Euro BOBL' },
          ],
        },
      ],
    });
    container.appendChild(script);
  
    return () => {
      // Wipe it all out on unmount so the next mount starts fresh
      container.innerHTML = '';
    };
  }, []);
 



  const { setUser } = useContext(UserContext);
  const [marketOpen, SetMarketOpen] = useState(false);
  const [view, setView] = useState("Core Fund"); // "news" or "featured"
  const [featured, setFeatured] = useState([]);       // raw rows from DB
const [featuredData, setFeaturedData] = useState([]); 
  const [favData, setFavData] = useState(null);

  // Watchlist pagination
const [wlPage, setWlPage] = useState(0);
const wlPageSize = 6;

const wlTotal = stockData?.length || 0;
const wlTotalPages = Math.max(1, Math.ceil(wlTotal / wlPageSize));

useEffect(() => {
  // reset to first page when the dataset size changes
  setWlPage(0);
}, [wlTotal]);

const visibleStocks = useMemo(() => {
  if (!stockData || !stockData.length) return [];
  const start = wlPage * wlPageSize;
  return stockData.slice(start, start + wlPageSize);
}, [stockData, wlPage]);

const prevWl = () => setWlPage(p => (p - 1 + wlTotalPages) % wlTotalPages); // loop
const nextWl = () => setWlPage(p => (p + 1) % wlTotalPages);               // loop
// If you prefer non-looping, use:
// const prevWl = () => setWlPage(p => Math.max(0, p - 1));
// const nextWl = () => setWlPage(p => Math.min(wlTotalPages - 1, p + 1));

  const handleFetchData = (data) => {
    setStockData(data);
  };
  const [marketPrice, setMarketPrice] = useState(null);
  const [VIXmarketPrice, setVIXMarketPrice] = useState(null);
  const timestamp = new Date().getTime();
  useEffect(() => {
  let abort = false;

  (async () => {
    try {
      const { data } = await axios.get("https://stocksleuth.xyz:5000/getFeaturedStocks");
      const rows = data?.featuredStocks || [];
      if (!abort) setFeatured(rows);
    } catch (e) {
      console.error("Failed to load featured stocks", e);
      if (!abort) setFeatured([]);
    }
  })();

  return () => { abort = true; };
}, []);
useEffect(() => {
  let abort = false;

  (async () => {
    if (!featured?.length) {
      setFeaturedData([]);
      return;
    }

    try {
      const cards = [];
      for (const row of featured) {
        const ticker = (row.ticker || "").toUpperCase();
        if (!ticker) continue;

        const details = await fetchStockDetails(ticker);

        cards.push({
          id: row.id,
          ticker,
          shortName: details.shortName,
          logo: details.logo,
          sector: details.sector,
          industry: details.industry,
          addedAt: row.date_added,
          link: `/stock/${ticker}`,
        });
      }

      cards.sort((a, b) => new Date(b.addedAt) - new Date(a.addedAt));
      if (!abort) setFeaturedData(cards);
    } catch (e) {
      console.error("Failed to hydrate featured", e);
      if (!abort) setFeaturedData([]);
    }
  })();

  return () => { abort = true; };
}, [featured]);

  const location = useLocation();
  const [newsItems, setNewsItems] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // new /news call
        const newsResponse = await axios.get(
          "https://stocksleuth.xyz:5000/news"
        );

        setNewsItems(newsResponse.data.items);
      } catch (err) {
        console.error(err);
      } finally {
      }
    };

    fetchData();
  }, []);



  function timeAgo(dateString) {
    const now = new Date();
    const then = new Date(dateString);  // your pubDate is UTC, JS Date will parse it correctly
    const diffMs      = now - then;
    const diffSecs    = Math.floor(diffMs / 1000);
    const diffMins    = Math.floor(diffSecs / 60);
    if (diffMins < 1)  return 'just now';
    if (diffMins < 60) return `${diffMins} minute${diffMins !== 1 ? 's' : ''} ago`;
  
    const diffHrs = Math.floor(diffMins / 60);
    if (diffHrs < 24) return `${diffHrs} hour${diffHrs !== 1 ? 's' : ''} ago`;
  
    const diffDays = Math.floor(diffHrs / 24);
    if (diffDays < 30) return `${diffDays} day${diffDays !== 1 ? 's' : ''} ago`;
  
    const diffMonths = Math.floor(diffDays / 30);
    return `${diffMonths} month${diffMonths !== 1 ? 's' : ''} ago`;
  }
  const [chartData, setChartData] = useState({ series: [], options: {} });

const [sp500PriceHistory, setSp500PriceHistory] = useState([]);
const [range, setRange] = useState("ytd"); // could be dynamic later
const [portfolioValueHistory, setPortfolioValueHistory] = useState([]); // dummy initial value
  useEffect(() => {
    const controller = new AbortController();

    async function fetchData() {
      try {


        const proxyUrl = "https://stocksleuth.xyz:5000/call?url=";
        const apiUrl = `https://query1.finance.yahoo.com/v8/finance/chart/^GSPC?interval=1d&range=${range}`;
        const apiUrl2 = `https://query1.finance.yahoo.com/v8/finance/chart/tgt?interval=1d&range=${range}`;
        const encodedApiUrl = encodeURIComponent(apiUrl);
        const encodedApiUrl2 = encodeURIComponent(apiUrl2);

        const response = await axios.get(proxyUrl + encodedApiUrl, {
          signal: controller.signal,
        });
        const response2 = await axios.get(proxyUrl + encodedApiUrl2, {
          signal: controller.signal,
        });
        const Result2 = response2?.data?.chart?.result?.[0];
        const closes2 = Result2?.indicators?.quote?.[0]?.close || [];
        const result = response?.data?.chart?.result?.[0];
        const ts = result?.timestamp || [];
        const closes = result?.indicators?.quote?.[0]?.close || [];

        // Pair and clean: [{ t: ms, close }]
        const paired = ts
          .map((sec, i) => ({ t: sec * 1000, close: closes[i] }))
          .filter(p => Number.isFinite(p.close));
        const paired2 = ts
          .map((sec, i) => ({ t: sec * 1000, close: closes2[i] }))
          .filter(p => Number.isFinite(p.close));
setPortfolioValueHistory(paired2);
console.log("S&P 500 price history:", paired);
        setSp500PriceHistory(paired);
      } catch (err) {
        if (err?.code === "ERR_CANCELED") return;
      } 
    }

    fetchData();
    return () => controller.abort();
  }, []);

  useEffect(() => {


    if (!sp500PriceHistory.length || !portfolioValueHistory.length) return;

    // Normalize both to 100 baseline
    const base1 = sp500PriceHistory[0]?.close;
    const base2 = portfolioValueHistory[0]?.close;

    const norm1 = sp500PriceHistory.map(p => ({
      x: p.t,
      y: (p.close / base1) * 100,
    }));
    const norm2 = portfolioValueHistory.map(p => ({
      x: p.t,
      y: (p.close / base2) * 100,
    }));

    setChartData({
      series: [
        {
          name: "^GSPC",
          type: "line",
          data: norm1,
        },
        { name: "Portfolio", type: "line", data: norm2 },
      ],
      options: {
        stroke: {
          width: [1.5],
          colors: ["#72727252", "#5932ea"],
          curve: "smooth",
        },
        legend: { show: false },
        tooltip: {
          enabled: false,
          marker: { show: false },
          onDatasetHover: { highlightDataSeries: false },
          followCursor: false,
          intersect: false,
        },
        chart: {
          type: "line",
          toolbar: { autoSelected: "none", show: false },
          animations: { enabled: true },
        },
        states: {
          normal: { filter: { type: "none", value: 0 } },
          hover: { filter: { type: "none", value: 0 } },
        },
        grid: { position: "back", borderColor: "#FDFBFF" },
        annotations: {
          yaxis: [
            {
              y: 100,
              borderColor: "#b8b8b8ff",
              strokeDashArray: 5,
              
            },
          ],
        },
        xaxis: {
          type: "datetime",
          tickAmount: 4,
          axisTicks: { show: false },
          labels: {
            style: { cssClass: "RemoveFirstDate" },
            formatter: (val) => {
              if (["1d"].includes(range)) return dayjs(val).format("HH:mm");
              if (["5d", "1mo", "3mo", "6mo"].includes(range)) return dayjs(val).format("DD.MM");
              if (["1y", "2y", "5y", "ytd", "max"].includes(range)) return dayjs(val).format("MMM YYYY");
              return dayjs(val).format("MMM YY");
            },
            rotate: 0,
          },
          crosshairs: { show: false },
          tooltip: { enabled: false },
        },
        yaxis: {
          opposite: true,
          tickAmount: 10,
          labels: {
            formatter: (val) => (val !== null ? Number(val).toFixed(2) : val),
          },
          forceNiceScale: true,
          tooltip: { enabled: false },
          crosshairs: { show: false },
        },
        markers: { size: 0 },
      },
    });
  }, [sp500PriceHistory]);



  useEffect(() => {
    const fetchFavoriteStockData = async (ticker) => {
      const proxyUrl = "https://stocksleuth.xyz:5000/call?url=";
      const apiUrl = `https://query1.finance.yahoo.com/v8/finance/chart/${ticker}?interval=1d&range=1d`;
      const encodedApiUrl = encodeURIComponent(apiUrl);
      const response = await axios.get(proxyUrl + encodedApiUrl);

      const chartData = response.data.chart.result[0];
      const currentPrice = chartData.meta?.regularMarketPrice;
      const previousClose = chartData.meta?.chartPreviousClose;

      // Calculate the daily change
      const dailyChange = currentPrice - previousClose;

      // Calculate the percentage change
      const percentageChange =
        ((currentPrice - previousClose) / previousClose) * 100;

      return {
        ticker: ticker,
        price: currentPrice ? parseFloat(currentPrice).toFixed(2) : null,
        dailyChange: dailyChange ? parseFloat(dailyChange).toFixed(2) : null,
        percentageChange: percentageChange ? percentageChange.toFixed(2) : null,
      };
    };

    const fetchShortName = async (ticker) => {
      const proxyUrl = "https://stocksleuth.xyz:5000/call?url=";
      const apiUrl = `https://query1.finance.yahoo.com/v1/finance/search?q=${ticker}`;
      const encodedApiUrl = encodeURIComponent(apiUrl);
      const response = await axios.get(proxyUrl + encodedApiUrl);

      const quotes = response.data.quotes;
      if (quotes.length > 0) {
        return quotes[0].shortname;
      } else {
        return "Unknown"; // If no short name is found
      }
    };

      const fetchFavoritesData = async () => {
    try {
      const favoritesResponse = await getFavorites();

      const res = await axios.get(
        "https://stocksleuth.xyz:5000/api/earnings-calendar"
      );
      setEarnings(res.data);

      const {
        favorites = [],
        resultsArray = [],
        watchlists: wlFromApi = {},
      } = favoritesResponse.data || {};

      setFavData(resultsArray);
      setWatchlists(wlFromApi);

      // --- decide which watchlist is "active" ---
      let effectiveId = activeWatchlistId;

      // if activeWatchlistId is not valid (e.g., first load), fall back to "1" or first key
      if (!wlFromApi[effectiveId]) {
        if (wlFromApi["1"]) {
          effectiveId = "1";
        } else {
          const firstKey = Object.keys(wlFromApi)[0];
          effectiveId = firstKey || null;
        }
        if (effectiveId) {
          setActiveWatchlistId(effectiveId);
        }
      }

      // map symbol → row for quick lookup
      const bySymbol = new Map(
        resultsArray.map((row) => [row.symbol, row])
      );

      // pick tickers from the active watchlist, or fall back to flat favorites list
      const tickersToShow =
        effectiveId && wlFromApi[effectiveId]?.components?.length
          ? wlFromApi[effectiveId].components
          : favorites;

      const stockDataArray = [];

      for (const ticker of tickersToShow) {
        if (!ticker) continue;

        // 1) DB row with metrics
        const row = bySymbol.get(ticker);
        if (!row) continue;

        // 2) logo
        let logo = null;
        try {
          const stockDetailsResponse = await fetch(
            `https://stocksleuth.xyz:5000/auth/getstockdetails?symbol=${ticker}`
          );
          const stockDetails = await stockDetailsResponse.json();
          if (stockDetails.logo) {
            const logoBuffer = new Uint8Array(stockDetails.logo.data);
            const base64Logo = btoa(
              String.fromCharCode.apply(null, logoBuffer)
            );
            logo = `data:image/png;base64,${base64Logo}`;
          }
        } catch {
          console.log("empty logo");
        }

        stockDataArray.push({
          logo,
          pe: row.pe,
          pb: row.pb,
          ps: row.ps,
          eps: row.eps,
          mktCap: row.mktCap,
          beta: row.beta,
          price: row.price,
          shortName: row.security_name,
          ticker,
        });
      }

      setStockData(stockDataArray);
    } catch (error) {
      console.error("Error fetching favorites data:", error);
    }
  };


    fetchFavoritesData();
}, [isUserSet, activeWatchlistId]);

  const getEmoji = (when) => {
    if (!when) return "";
    if (when.toLowerCase().includes("before")) return "☀️";
    if (when.toLowerCase().includes("after")) return "🌑";
    return "";
  };
const groupedEarnings = useMemo(() => {
  const acc = {};
  earnings.forEach((entry) => {
    const name = entry?.security_name
      ? modifySecurityName(entry.security_name).trim()
      : "";
    if (!name || name === "-") return;

    // ✅ force YYYY-MM-DD in Warsaw time
    const dateKey = dayjs(entry.date).tz("Europe/Warsaw").format("YYYY-MM-DD");

    if (!acc[dateKey]) acc[dateKey] = [];
    acc[dateKey].push(entry);
  });
  return acc;
}, [earnings]);

const formatSales = (v) => {
  const n = Number(v);
  if (!Number.isFinite(n)) return "-";

  if (n >= 1_000_000_000) return (n / 1_000_000_000).toFixed(2) + "B";
  if (n >= 1_000_000)     return (n / 1_000_000).toFixed(2) + "M";
  if (n >= 1_000)         return (n / 1_000).toFixed(2) + "K";
  return n.toFixed(2);
};

  function renderLogo(logoData) {
    const logoBuffer = new Uint8Array(logoData.data); // Use Uint8Array to convert binary data
    const base64Logo = btoa(String.fromCharCode.apply(null, logoBuffer)); // Convert to base64
    const imgSrc = `data:image/png;base64,${base64Logo}`;
    return <img className="logoSmall" src={imgSrc} alt="Logo" />;
  }

const activeWatchlistName =
  (watchlists[activeWatchlistId]?.name) || "Your Watchlist";

const handleRemoveFromActiveWatchlist = async (ticker) => {
  if (!ticker || !activeWatchlistId || !user?.displayname || removingTicker) return;

  const symbol = ticker.toUpperCase();

  try {
    setRemovingTicker(symbol);

    const { data } = await removeFavorite(symbol, activeWatchlistId);

    setStockData((prev) =>
      Array.isArray(prev) ? prev.filter((stock) => stock.ticker !== symbol) : prev
    );

    setWatchlists((prev) => {
      const fromApi = data?.favorites;
      if (fromApi && typeof fromApi === "object") return fromApi;

      const current = prev[activeWatchlistId];
      if (!current) return prev;

      return {
        ...prev,
        [activeWatchlistId]: {
          ...current,
          components: Array.isArray(current.components)
            ? current.components.filter((item) => item !== symbol)
            : [],
        },
      };
    });
  } catch (error) {
    console.error("Could not remove stock from watchlist", error);
    window.alert("Could not remove this stock from the watchlist. Please try again.");
  } finally {
    setRemovingTicker(null);
  }
};

  if (!isLoggedIn) return <LandingPage />;

  return (
    <div
      style={{ left: 0, right: "var(--sidebar-width, 306px)", overflow: "auto", position: "relative" }}
      className="OtherContent"
    >
      <Helmet>
        <title>StockSleuth | Portfolio Tracker &amp; Stock Research</title>
        <meta
          name="description"
          content="Track your portfolio, research stocks, screen investment opportunities, and test strategies with StockSleuth."
        />
        <link rel="canonical" href="https://stocksleuth.xyz/" />
        <meta property="og:title" content="StockSleuth | Portfolio Tracker &amp; Stock Research" />
        <meta
          property="og:description"
          content="Track your portfolio, research stocks, screen investment opportunities, and test strategies with StockSleuth."
        />
        <meta property="og:url" content="https://stocksleuth.xyz/" />
      </Helmet>
      {/*

	<div style={{display: "flex", flexWrap: "wrap", width: "100%", height: "100%", position: "relative", top: "10.74%", left: "1.7578125vh", overflow: "hidden"}}>
		<div style={{marginRight: '2.74%', marginBottom: '-10vh', width: '57.36%', height: '52.83vh', background: '#E6E8FD', borderRadius: 57}} />
		<div style={{marginBottom: '-10vh', width: "35.68%", height: '52.83%', background: '#F0FDE6', borderRadius: 54}} />
		<div style={{marginRight: '2.74%', width: '51.97%', height: '31.93%', background: '#FDE6F6', borderRadius: 57}} ><p style={{fontSize: 20,marginTop: '20px', marginLeft: '40px', textAlign: 'left'}}>Your Portfolio</p></div>
		<div style={{width: '41.26%', height: '31.93%', background: '#FDF4E6', borderRadius: 54}} />
	</div>
	*/}

      {/*{isLoggedIn ? (<>*/}
      <div className="whiteBarTop"></div>
        <>
          <div className="SomethingTop"></div>

          <div className="BigContainer dashboardPrimaryGrid">
            
            <div className="bigbox">
<div
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "10px",
    paddingLeft: 18,
    paddingRight: 18,
  }}
>
  <div
  style={{
    display: "flex",
    alignItems: "center",
    gap: 6,
  }}
>
  {/* Click = open centered manager modal */}
  <button
    onClick={openWatchlistManager}
    style={{
      display: "flex",
      alignItems: "center",
      gap: 6,
      border: "none",
      background: "transparent",
      padding: 0,
      cursor: "pointer",
      color: "#fff",
      fontFamily: "Poppins",
    }}
  >
    <span
      style={{
        fontFamily: "Poppins",
        fontSize: 24,
        fontWeight: 600,
      }}
    >
      {activeWatchlistName}
    </span>
    <span
      style={{
        fontSize: 14,
        transform: wlModalOpen ? "rotate(180deg)" : "none",
        transition: "transform 0.15s ease",
      }}
    >
      ▼
    </span>
  </button>

  {/* NEW unified manager modal */}
  {wlModalOpen && (
    <div
      className="watchlistManagerOverlay"
      style={{
        position: "fixed",
        inset: "0px 0px 0px 1px",
        background: "rgba(0,0,0,0.45)",
        zIndex: 100,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: "var(--sidebar-width, 306px)",
      }}
      onClick={() => setWlModalOpen(false)} // click outside closes
    >
      <div
        className="watchlistManagerCard"
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#ffffff",
          borderRadius: 18,
          padding: "18px 20px 16px",
          width: "100%",
          maxWidth: 420,
          maxHeight: "80vh",
          boxShadow: "0 20px 40px rgba(0,0,0,0.35)",
          fontFamily:
            "Poppins, system-ui, -apple-system, BlinkMacSystemFont",
          display: "flex",
          flexDirection: "column",
          gap: 12,
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 4,
          }}
        >
          <div>
            <div
              style={{
                fontSize: 16,
                fontWeight: 600,
                textAlign: "left",
              }}
            >
              Manage watchlists
            </div>
            <div
              style={{
                fontSize: 12,
                color: "#6b7280",
                textAlign: "left",
                marginTop: 2,
              }}
            >
              Switch between lists, rename or remove them.
            </div>
          </div>

          <button
            type="button"
            onClick={() => setWlModalOpen(false)}
            style={{
              border: "none",
              background: "transparent",
              cursor: "pointer",
              fontSize: 18,
              lineHeight: 1,
              padding: 4,
            }}
          >
            ×
          </button>
        </div>

        {/* List of watchlists */}
        <div
          style={{
            borderRadius: 12,
            border: "1px solid #e5e7eb",
            padding: 6,
            maxHeight: 220,
            overflowY: "auto",
          }}
        >
          {Object.keys(watchlists).length === 0 && (
            <div
              style={{
                padding: "8px 10px",
                fontSize: 13,
                color: "#6b7280",
                textAlign: "left",
              }}
            >
              No watchlists yet. Create your first one below.
            </div>
          )}

          {Object.entries(watchlists).map(([id, wl]) => {
            const isActive = id === activeWatchlistId;
            return (
              <div
                key={id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "6px 8px",
                  borderRadius: 8,
                  cursor: "pointer",
                  backgroundColor: isActive
                    ? "rgba(89,50,234,0.06)"
                    : "transparent",
                  transition: "background-color 0.12s ease",
                }}
                onClick={() => {
                  setActiveWatchlistId(id);
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                >
                  <div
                    style={{
                      width: 16,
                      height: 16,
                      borderRadius: "999px",
                      border: "1px solid #9ca3af",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: isActive ? "#5932ea" : "#fff",
                    }}
                  >
                    {isActive && (
                      <div
                        style={{
                          width: 8,
                          height: 8,
                          borderRadius: "999px",
                          backgroundColor: "#fff",
                        }}
                      />
                    )}
                  </div>
                  <span
                    style={{
                      fontSize: 13,
                      fontWeight: isActive ? 600 : 500,
                      color: isActive ? "#111827" : "#374151",
                    }}
                  >
                    {wl.name || `Watchlist ${id}`}
                  </span>
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: 6,
                    alignItems: "center",
                  }}
                >
                  <button
                    type="button"
                    style={{
                      border: "none",
                      background: "transparent",
                      fontSize: 11,
                      cursor: "pointer",
                      padding: 2,
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      openRenameWatchlistModal(id);
                    }}
                  >
                    ✏️
                  </button>
                  {id !== "1" && (
                    <button
                      type="button"
                      style={{
                        border: "none",
                        background: "transparent",
                        fontSize: 11,
                        cursor: "pointer",
                        padding: 2,
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteWatchlist(id);
                      }}
                    >
                      🗑
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        {/* Error (if any) */}
        {wlError && (
          <div
            style={{
              color: "#dc2626",
              fontSize: 12,
              marginTop: 2,
              textAlign: "left",
            }}
          >
            {wlError}
          </div>
        )}

        {/* Create / rename form in same modal */}
        <form onSubmit={handleWatchlistModalSubmit}>
          <div
            style={{
              marginTop: 8,
              marginBottom: 8,
              textAlign: "left",
            }}
          >
            <div
              style={{
                fontSize: 12,
                fontWeight: 600,
                marginBottom: 4,
              }}
            >
              {wlModalMode === "create"
                ? "Create new watchlist"
                : "Rename watchlist"}
            </div>
            <input
              value={wlModalName}
              onChange={(e) => setWlModalName(e.target.value)}
              placeholder={
                wlModalMode === "create"
                  ? "e.g. Core Holdings"
                  : "New name"
              }
              style={{
                width: "100%",
                border: "none",
                borderBottom: "1px solid #e5e7eb",
                outline: "none",
                padding: "6px 0 8px",
                fontSize: 14,
              }}
            />
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 8,
              marginTop: 2,
            }}
          >
            <button
              type="button"
              onClick={() => {
                setWlModalOpen(false);
              }}
              style={{
                border: "none",
                background: "transparent",
                fontSize: 13,
                padding: "6px 10px",
                cursor: "pointer",
              }}
            >
              Close
            </button>
            <button
              type="submit"
              disabled={wlSaving}
              style={{
                border: "none",
                background: "#4e27d8",
                color: "#ffffff",
                borderRadius: 12,
                padding: "6px 14px",
                fontSize: 13,
                cursor: wlSaving ? "default" : "pointer",
                opacity: wlSaving ? 0.7 : 1,
              }}
            >
              {wlSaving
                ? "Saving..."
                : wlModalMode === "create"
                ? "Create"
                : "Save"}
            </button>
          </div>
        </form>
      </div>
    </div>
  )}
</div>


{wlTotalPages > 1 && (
  <div style={{ display: "flex", alignItems: "flex-end", gap: 0 }}>
    <button
      onClick={prevWl}
      aria-label="Previous page"
      style={{
        background: "transparent",
        border: "none",
        color: "#fff",
        fontSize: 18,
        cursor: "pointer",
        padding: "4px 8px",
      }}
    >
      &lt;
    </button>


    <button
      onClick={nextWl}
      aria-label="Next page"
      style={{
        background: "transparent",
        border: "none",
        color: "#fff",
        fontSize: 18,
        cursor: "pointer",
        padding: "4px 8px",
      }}
    >
      &gt;
    </button>
  </div>)}
</div>
              <div className="overlap-9" style={{ top: 0, height: "calc(100% - 45px)" }}>
                <div className="WatchlistTable" style={{ width: "100%" }}>
                  <table className="Watchlist">
                    <thead>
                      <tr>
                        <th>Company</th>
                        {selectedCols.map((key) => {
      const cfg = COLUMN_CONFIG.find((c) => c.key === key);
      return <th key={key}>{cfg?.label || key}</th>;
    })}
                        <th style={{ width: 40, padding: 0, position: "relative" }}>
  <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
    <button
      ref={gearBtnRef}
      onClick={() => setColPickerOpen((v) => !v)}
      aria-label="Watchlist settings"
      style={{
        border: "none",
        background: "transparent",
        cursor: "pointer",
        padding: 4,
        borderRadius: 6,
      }}
    >
      <GearIcon />
    </button>
  </div>

  {colPickerOpen && (
    <div
      id="col-picker-pop"
      style={{
        position: "absolute",
        top: "100%",
        right: 0,
        marginTop: 8,
        zIndex: 10,
        fontFamily: "Poppins",
        background: "#fff",
        border: "1px solid #e5e7eb",
        borderRadius: 10,
        boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
        padding: 12,
        width: 220,
      }}
    >
      <div style={{ fontWeight: 600, marginBottom: 8, fontSize: 13, textAlign: "left" }}>
        Visible columns
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 6, maxHeight: 250, overflowY: "auto" }}>
        {COLUMN_CONFIG.map(({ key, label }) => {
          const checked = selectedCols.includes(key);
          return (
            <label key={key} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13 }}>
              <input
                type="checkbox"
                checked={checked}
                onChange={(e) => {
                  const next = e.target.checked
                    ? Array.from(new Set([...selectedCols, key]))
                    : selectedCols.filter((k) => k !== key);
                  setSelectedCols(next);
                  saveSelectedColumns(next);
                }}
              />
              <span>{label}</span>
            </label>
          );
        })}
      </div>
      <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
        <button
          onClick={() => {
            setSelectedCols(DEFAULT_SELECTED);
            saveSelectedColumns(DEFAULT_SELECTED);
          }}
          style={{
            border: "1px solid #e5e7eb",
            background: "#f9fafb",
            borderRadius: 8,
            padding: "6px 10px",
            fontSize: 12,
            cursor: "pointer",
          }}
        >
          Reset
        </button>
        <button
          onClick={() => setColPickerOpen(false)}
          style={{
            border: "none",
            background: "#5932ea",
            color: "#fff",
            borderRadius: 8,
            padding: "6px 10px",
            fontSize: 12,
            cursor: "pointer",
            marginLeft: "auto",
          }}
        >
          Done
        </button>
      </div>
    </div>
  )}
</th>
                      </tr>
                    </thead>
                     <tbody>
 {(() => {
    // build a 6-long array: real items first, then nulls as fillers
    const padded = (() => {
      if (!visibleStocks || !visibleStocks.length) return Array.from({ length: wlPageSize }, () => null);
      const arr = visibleStocks.slice(0, wlPageSize);
      while (arr.length < wlPageSize) arr.push(null);
      return arr;
    })();

    return padded.map((stock, idx) => {
      if (stock) {
        // === normal populated row ===
        return (
          <tr key={stock.ticker} style={{ height: 64 }}>
            {/* Company (fixed) */}
            <td>
              <a
                href={`/stock/${stock.ticker}`}
                style={{ textDecoration: "none", color: "inherit", display: "flex", alignItems: "center", gap: 10 }}
              >
                <div className="imageContainerWatchlist">
                  {stock.logo ? (
                    <img
                      src={stock.logo}
                      alt={stock.ticker}
                      style={{ maxWidth: "25px", maxHeight: "25px", objectFit: "contain" }}
                    />
                  ) : (
                    <p style={{ fontSize: 20, color: "#9c9c9c", fontWeight: 600 }}>
                      {stock.ticker ? stock.ticker[0] : ""}
                    </p>
                  )}
                </div>
                <div>
                  <p style={{ margin: 0, fontSize: 14 }}>{modifySecurityName(stock.shortName)}</p>
                  <p style={{ margin: 0, fontSize: 10, color: "rgb(103 103 107)" }}>{stock.ticker}</p>
                </div>
              </a>
            </td>

            {/* Dynamic cells from selectedCols */}
            {selectedCols.map((key) => {
              let content = "-";
              switch (key) {
                case "price":
                  content = formatNumber(Number(stock.price), 2);
                  break;
                case "pe":
                  content = !isNaN(stock.pe) ? formatNumber(Number(stock.pe), 2) : "-";
                  break;
                case "ps":
                  content = !isNaN(stock.ps) ? formatNumber(Number(stock.ps), 2) : "-";
                  break;
                case "pb":
                  content = !isNaN(stock.pb) ? formatNumber(Number(stock.pb), 2) : "-";
                  break;
                case "eps":
                  content = !isNaN(stock.eps) ? formatNumber(Number(stock.eps), 2) : "-";
                  break;
                case "nextEarningsDate":
                  content = stock.nextEarningsDate || "-";
                  break;
                case "mktCap":
                  content = typeof stock.mktCap === "number" ? formatMarketCap(stock.mktCap * 1_000_000) : "-";
                  break;
                case "changePct":
                  content =
                    typeof stock.percentageChange === "number"
                      ? `${formatNumber(stock.percentageChange, 2)}%`
                      : "-";
                  break;
                case "fiftyTwoW":
                  if (typeof stock.fiftyTwoWHigh === "number" && typeof stock.fiftyTwoWLow === "number") {
                    content = `${formatNumber(stock.fiftyTwoWLow, 2)}–${formatNumber(stock.fiftyTwoWHigh, 2)}`;
                  } else content = "-";
                  break;
                default:
                  content = "-";
              }
              const isNumeric = ["price", "pe", "ps", "pb", "eps", "mktCap", "changePct", "fiftyTwoW"].includes(key);
              return (
                <td key={key} style={{ textAlign: isNumeric ? "center" : "left" }}>
                  {content}
                </td>
              );
            })}

            {/* Remove from the currently active watchlist */}
            <td style={{ textAlign: "center", padding: 0 }}>
              <button
                type="button"
                onClick={() => handleRemoveFromActiveWatchlist(stock.ticker)}
                disabled={removingTicker === stock.ticker}
                aria-label={`Remove ${stock.ticker} from ${activeWatchlistName}`}
                title={`Remove from ${activeWatchlistName}`}
                style={{
                  width: 14,
                  height: 14,
                  border: "none",
                  background: "transparent",
                  color: "#111111",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: 0,
                  fontSize: 12,
                  lineHeight: 1,
                  fontWeight: 600,
                  cursor: removingTicker === stock.ticker ? "default" : "pointer",
                  opacity: removingTicker === stock.ticker ? 0.3 : 0.72,
                  transition: "opacity 0.12s ease, transform 0.12s ease",
                }}
                onMouseEnter={(e) => {
                  if (removingTicker !== stock.ticker) {
                    e.currentTarget.style.opacity = "1";
                    e.currentTarget.style.transform = "scale(1.12)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (removingTicker !== stock.ticker) {
                    e.currentTarget.style.opacity = "0.72";
                    e.currentTarget.style.transform = "scale(1)";
                  }
                }}
              >
                −
              </button>
            </td>
          </tr>
        );
      }

      // === filler empty row (keeps 6 rows visible) ===
      return (
        <tr key={`empty-${idx}`} style={{ height: 64, opacity: 0.65 }}>
          {/* Company cell blank */}
          <td>
            <div style={{ height: 20 }} />
          </td>
          {/* One blank td per selected column */}
          {selectedCols.map((key) => (
            <td key={`empty-${idx}-${key}`} />
          ))}
          {/* gear-align column */}
          <td />
        </tr>
      );
    });
  })()}

      

</tbody>

                  </table>
                </div>
              </div>
            </div>
            <div className="favebox">
                            <h2 className="termOfDayHeading" style={{fontFamily: "Poppins", color: "#fff", margin: 0, alignSelf: "flex-start", textAlign: "left", marginBottom: "10px", paddingLeft: 18, fontSize: 24, fontWeight: "600"}}>Term of the day</h2>

              <div className="overlap-9" style={{ top: 0, height: "calc(100% - 45px)"  }}>
                {tod && <div
                  style={{
                    height: "100%",
                    maxHeight: "300px",
                    overflowY: "auto",
                  }}
                >
                  {tod.formula ? (
        tod.display === "block" ? (
          <div style={{ padding: "12px 18px 0" }}>
            <BlockMath math={tod.formula} />
          </div>
        ) : (
          <div style={{ fontSize: 14, color: "#000000ff", textAlign: "center", paddingTop: 8 }}>
            <InlineMath math={tod.formula} />
          </div>
        )
      ) : null}
                  <h3
                    style={{
                      margin: 0,
                      paddingLeft: 18,
                      paddingRight: 18,
                      paddingTop: tod.formula ? 0 : 20,
                      fontSize: 26,
                      textAlign: "left",
                      fontWeight: "600",
                      fontFamily: "Poppins",
                      position: "sticky",
                      top: 0,
                    }}
                  >
                    {tod.term}
                  </h3>
                  
                    <p style={{ padding: "6px 18px", margin: 0, textAlign: "left", fontSize: 14 }}>{tod.definition}
</p>
                  
                  
                </div>}
              </div>
            </div>
          </div>
          <div className="BigContainer" style={{marginTop: 20 }}>
            <div className="Bigbox">
                            <h2 style={{fontFamily: "Poppins", color: "black", margin: 0, alignSelf: "flex-start", textAlign: "left", marginBottom: "10px", paddingLeft: 18, fontSize: 20, fontWeight: "600"}}>Earnings Calendar</h2>

            <div
              style={{
                flex: 1,
                height: 400,
                backgroundColor: "white",
                
                overflow: "auto",
              }}
              class="overlap-9"
            >
              <table className="Watchlist">
                <thead>
                  <tr>
                    <th
                      style={{
                        textDecoration: "none",
                        color: "black",
                        width: "50%",
                        backgroundColor: "white",
                      }}
                    >
                      Company
                    </th>
                    <th style={{ backgroundColor: "white", textDecoration: "none", color: "black" }}>
                      Ticker
                    </th>
                    <th style={{ backgroundColor: "white", backgroundColor: "white", textAlign: "center" }}>Estimated EPS</th>
                    <th style={{ backgroundColor: "white", textAlign: "center" }}>Estimated Revenue</th>
                    <th style={{ backgroundColor: "white", textAlign: "left" }}>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(groupedEarnings).map((date, idx) => (
                    <React.Fragment key={idx}>
                      {/* Sticky Date Row */}
                      <tr>
                        <td
                          colSpan="5"
                          className="dateHeaderRow"
                          style={{
                            position: "sticky",
                            top: "38.5px",
                            zIndex: "1",
                            padding: "10px",
                            textAlign: "left",
                            paddingLeft: 30,
                            height: "auto",
                          }}
                        >
                          {date}
                        </td>
                      </tr>

                      {groupedEarnings[date]
                        .slice()
                        .sort((a, b) => {
                          const getEmojiSortOrder = (when) => {
                            const emoji = getEmoji(when);
                            if (emoji === "☀️") return 0;
                            if (!emoji) return 1;
                            if (emoji === "🌑") return 2;
                            return 3;
                          };
                          return (
                            getEmojiSortOrder(a.when) -
                            getEmojiSortOrder(b.when)
                          );
                        })
                        .map((entry, entryIdx) => (
                          <tr key={entryIdx}>
                            <td style={{ textAlign: "center" }}>
                              <a
                                href={`/stock/${entry.act_symbol}`}
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 10,
                                }}
                              >
                                {entry.logo ? (
                                  renderLogo(entry.logo)
                                ) : (
                                  <div className="logoSmallAlt">
                                    <p
                                      style={{
                                        fontSize: 14,
                                        color: "#9c9c9c",
                                        fontWeight: 600,
                                        margin: 0,
                                      }}
                                    >
                                      {entry.act_symbol
                                        ? entry.act_symbol[0]
                                        : ""}
                                    </p>
                                  </div>
                                )}
                                {entry.security_name
                                  ? modifySecurityName(entry.security_name)
                                  : "-"}
                              </a>
                            </td>
                            <td>
                              <a
                                href={`/stock/${entry.act_symbol}`}
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                              >
                                {entry.act_symbol}
                              </a>
                            </td>
                            <td style={{ textAlign: "center" }}>
  {entry.eps_consensus != null ? Number(entry.eps_consensus).toFixed(2) : "-"}
</td>

<td style={{ textAlign: "center" }}>
  {entry.sales_consensus != null ? formatSales(Number(entry.sales_consensus)) : "-"}
</td>
                            <td
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-start",
                              }}
                            >
                              {dayjs(entry.date).tz("Europe/Warsaw").format("YYYY-MM-DD")} {getEmoji(entry.when) || "❔"}

                            </td>
                          </tr>
                        ))}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div></div>
            <div className="favebox" style={{minWidth: 300,}}>
              <h2 style={{fontFamily: "Poppins", color: "black", margin: 0, alignSelf: "flex-start", textAlign: "left", marginBottom: "10px", paddingLeft: 18, fontSize: 20, fontWeight: "600"}}>Overview</h2>

              <div className="overlap-9" style={{ top: 0, height: "calc(100% - 40px)" }}>
                <div
                  style={{
                    height: "100%",
                    //maxHeight: "300px",
                    overflowY: "auto",
                    borderRadius: 18,
                  }}
                >
                  <div style={{ marginTop: "-0.5px", marginLeft: "-0.5px", width: "calc(100% + 1px)", height: "calc(100% + 1px)" }}>
  <TradingViewOverview />
</div>
                  
                </div>
              </div>
            </div>
          </div>
          <div className="BigContainer dashboardPortfolioRow">
            <section className="dashboardPortfolioSnapshot" aria-labelledby="dashboard-portfolio-title">
              <div className="dashboardPortfolioSummary">
                <div>
                  <span className="dashboardPortfolioEyebrow">Portfolio</span>
                  <h2 id="dashboard-portfolio-title">Quick overview</h2>
                </div>
                {!portfolioSnapshot.loading && portfolioSnapshot.holdings.length > 0 && (
                  <div className="dashboardPortfolioPerformance">
                    <span>${portfolioSnapshot.marketValue.toLocaleString("en-US", { maximumFractionDigits: 0 })}</span>
                    <strong className={portfolioSnapshot.totalReturn >= 0 ? "isPositive" : "isNegative"}>
                      {portfolioSnapshot.totalReturn >= 0 ? "+" : ""}{portfolioSnapshot.totalReturn.toFixed(1)}%
                    </strong>
                    <small>all time</small>
                  </div>
                )}
              </div>
              <div className="dashboardTopHoldings">
                {portfolioSnapshot.loading ? (
                  <span className="dashboardPortfolioMuted">Loading portfolio…</span>
                ) : portfolioSnapshot.holdings.length ? (
                  portfolioSnapshot.holdings.map((holding) => (
                    <div className="dashboardHolding" key={holding.ticker}>
                      <span className="dashboardHoldingMark">{holding.ticker.charAt(0)}</span>
                      <div><strong>{holding.ticker}</strong><small>{holding.shares.toLocaleString("en-US")} shares</small></div>
                      <span>${holding.value.toLocaleString("en-US", { maximumFractionDigits: 0 })}</span>
                    </div>
                  ))
                ) : (
                  <span className="dashboardPortfolioMuted">No open positions yet.</span>
                )}
              </div>
              <Link className="dashboardPortfolioLink" to="/portfolio">View portfolio <span aria-hidden="true">→</span></Link>
            </section>
          </div>
          <div className="BigContainer" style={{marginTop: 20 }}>
            <div className="Bigbox">
                            <h2 style={{fontFamily: "Poppins", color: "black", margin: 0, alignSelf: "flex-start", textAlign: "left", marginBottom: "10px", paddingLeft: 18, fontSize: 20, fontWeight: "600"}}>Our Blog</h2>

            <div
              style={{
                flex: 1,
                height: 400,
                backgroundColor: "white",
                
                overflow: "auto",
              }}
              class="overlap-9"
            >
              <ArticleList count={5} />
            </div></div>
            <div className="favebox" style={{minWidth: 300,}}>
              <h2 style={{fontFamily: "Poppins", color: "black", margin: 0, alignSelf: "flex-start", textAlign: "left", marginBottom: "10px", paddingLeft: 18, fontSize: 20, fontWeight: "600"}}>Featured</h2>

              <div className="overlap-9" style={{ top: 0, height: "calc(100% - 40px)" }}>
                <div
                  style={{
                    height: "100%",
                    //maxHeight: "300px",
                    overflowY: "auto",
                    borderRadius: 18,
                  }}
                >
                  <div style={{ marginTop: "-0.5px", marginLeft: "-0.5px", width: "calc(100% + 1px)", height: "calc(100% + 1px)" }}>
<div style={{ padding: 12 }}>
  {featuredData && featuredData.length ? (
    <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 10 }}>
      {featuredData.map((item) => (
        <FeaturedCard key={`${item.id}-${item.ticker}`} item={item} />
      ))}
    </div>
  ) : (
    <div style={{ padding: 16, color: "#6b7280" }}>No highlights yet.</div>
  )}
</div>
</div>
                  
                </div>
              </div>
            </div>
          </div>
              
            
          <div className="BigContainer">
            <div
              style={{
                flex: 1,
                height: 400,
                backgroundColor: "white",
                marginTop: 20,
                overflow: "auto",
                display: "flex", alignItems: "stretch", justifyContent: "center",
                flexDirection: "column",
              }}
              className="overlap-9"
            >
              <div
        className="body-RangeSelector mobileRangeSelector"
        style={{
          display: 'flex',
          alignItems: 'center',
          backgroundColor: 'rgba(255, 255, 255, 0)',
          boxShadow: 'none',
          gap: 14,
          padding: '10px 30px',
        }}
      >
        <button
          className={`range-button ${view === 'Core Fund' ? 'active' : ''}`}
          onClick={() => setView('Core Fund')}
        >
          Core Fund
        </button>
        <button
          className={`range-button ${view === 'defensive' ? 'active' : ''}`}
          onClick={() => setView('defensive')}
        >
          Defensive 
        </button>
      </div>
 <Chart
      options={chartData.options}
      series={chartData.series}
      type="line"
      width={"100%"}
      height={340}
      
    />
              
            </div>
          </div>
          
          <div className="SomethingBottom" style={{ marginTop: 100 }}>
            <div></div>
            <div className="bottomCopyrightContainer">
              <p className="bottomText">© 2025 - StockSleuth</p>
              <p>
                <a className="privacylink" href="/privacy">
                  Privacy Policy
                </a>
              </p>
            </div>
          </div>
        </>
      {/* Legacy anonymous landing removed. The signed-out experience is LandingPage.
        <>
          <div className="SomethingTopHome"></div>
          <div className="SomethingTopBack" style={{ left: 0, right: "var(--sidebar-width, 306px)" }}>
            <h1 className="gradientTextBig">StockSleuth</h1>
            <h1 className="gradientText">
              The ultimate hub for smart investing
            </h1>
          </div>
          <div className="contentMiddle">
            <div className="cardObject">
              <div className="card36">
                <img alt="radar" className="imageHome" src={funnel} />
              </div>
              <h2 className="cardText">Scan</h2>
              <p className="smallTextD">
                Find the best stocks with powerful filters. Customize your
                search with criteria like market cap, P/E ratio, revenue growth,
                and more.
              </p>
            </div>
            <div className="cardObject">
              <div className="card36">
                <img alt="chart" className="imageHome" src={analuyz} />
              </div>
              <h2 className="cardText">Analyze</h2>
              <p className="smallTextD">
                Dive deep into stock valuations and financial reports. Use
                various technical analysis tools to identify market trends.
              </p>
            </div>
            <div className="cardObject">
              <div className="card36">
                <img alt="swipe" className="imageHome" src={swipe} />
              </div>
              <h2 className="cardText">Swipe</h2>
              <p className="smallTextD">
                Explore stocks effortlessly with a cards swipe feature. Quickly
                sort through potential investments and build your watchlist.
              </p>
            </div>
            <div className="cardObject">
              <div className="card36">
                <img alt="trophy" className="imageHome" src={compete} />
              </div>
              <h2 className="cardText">Compete</h2>
              <p className="smallTextD">
                Join exciting investing and trading tournaments with real
                rewards. Win cash prizes or premium memberships.
              </p>
            </div>
          </div>
          <div style={{ height: 160 }} />
          <div
            className="contentMiddle2"
            style={{ height: "70vh", flexDirection: "column" }}
          >
            <hr />
            <div
              style={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexDirection: "row",
              }}
            >
              <img className="Scaner" alt="radar" src={scanner} />
              <div
                style={{
                  width: "50%",
                  display: "flex",
                  height: "100%",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                className="sideTextBig"
              >
                Scanner
              </div>
            </div>
          </div>
          <div
            className="contentMiddle2"
            style={{ height: "70vh", flexDirection: "column" }}
          >
            <hr />
            <div
              style={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexDirection: "row",
              }}
            >
              <div
                style={{
                  width: "50%",
                  display: "flex",
                  width: "100%",
                  height: "100%",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                className="sideTextBig2"
              >
                Swiping
              </div>
              <img
                className="Scaner"
                alt="swipe"
                src={card2}
                style={{
                  borderRadius: 30,
                  marginRight: 50,
                  marginLeft: 0,
                  width: 300,
                }}
              />
            </div>
          </div>
          <div className="SomethingBottom">
            <div></div>
            <div className="bottomCopyrightContainer">
              <p className="bottomText">© 2025 - StockSleuth</p>
              <p>
                <a className="privacylink" href="/privacy">
                  Privacy Policy
                </a>
              </p>
            </div>
          </div>
        </>
      */}

      {/*) : (<div style={{width:'100vw', height: '100vh', position: 'static', left: '0px'}}><SignInPage/></div>)*/}
    </div>
  );
};
export default Dashboard;
